import { CMS_Content_Module_VideoGalleryDataVideo } from './types';
import { Video, VideoRef } from '@cue/molecules';
import { useMediaAnalytics } from '@project/hooks/use-media-analytics';
import React, { useEffect, useMemo, useRef } from 'react';
import { useSwiper, useSwiperSlide } from 'swiper/react';

export const VideoGalleryElement: React.FC<VideoGalleryElementProps> = (props) => {
  const { src, title, poster, index, onCurrentSlide, player_type = 'VideoGallery' } = props;
  const swiper = useSwiper();
  const swiperSlide = useSwiperSlide();

  /*  const [isActive, setIsActive] = useState(false);
  useEffect(() => {
    setIsActive(active);
  }, [active]); */
  const videoRef = useRef<VideoRef>(null);

  useEffect(() => {
    if (videoRef.current && !swiperSlide.isActive) {
      videoRef.current.stop();
    }
    if (swiperSlide.isActive) {
      onCurrentSlide && onCurrentSlide(index);
    }
  }, [swiperSlide.isActive, onCurrentSlide, index]);

  const video = useMemo(
    () => (
      <Video
        ref={videoRef}
        {...{
          playing: false,
          url: src,
          poster: poster.src,
        }}
        useMediaAnalytics={useMediaAnalytics}
        trackingTitle={JSON.stringify({ id:index, title })}
        trackingType={player_type}
      />
    ),
    [src, poster, title, player_type],
  );

  console.log('title', title);

  return (
    <div
      className={`cue-video-gallery-element ${
        swiperSlide.isActive ? 'cue-video-gallery-element-active' : ''
      }`}
      onClick={() => {
        if (!swiperSlide.isActive) swiper.slideTo(index);
      }}>
      {video}
    </div>
  );
};
export type VideoGalleryElementProps = CMS_Content_Module_VideoGalleryDataVideo & {
  index: number;
  onCurrentSlide?: (index: number) => void;
};
